import filtroOrgao from './filtro-orgao'
import filtroStatusLicitacao from './filtro-status-licitacao'
import valorParaReal from './valor-para-real'
import dataHumanizada from './dataHumanizada'
import textoSemValor from './texto-sem-valor'
import filtroSituacaoAnaliseCredenciamento from './filtro-situacao-solicitacao-credenciamento'
import formatarCpfCnpj from './formatarCpfCnpj'

export default {
    install(Vue) {
        Vue.filter('siglaOrgao', filtroOrgao)
        Vue.filter('statusLicitacao', filtroStatusLicitacao)
        Vue.filter('valorParaReal', valorParaReal)
        Vue.filter('dataHumanizada', dataHumanizada)
        Vue.filter('textoSemValor', textoSemValor)
        Vue.filter('filtroSituacaoAnaliseCredenciamento', filtroSituacaoAnaliseCredenciamento)
        Vue.filter('formatarCpfCnpj', formatarCpfCnpj)
    }

}

export {
    filtroOrgao,
    filtroStatusLicitacao,
    valorParaReal,
    dataHumanizada,
    textoSemValor
}
